import { isItemOfMessageType } from 'owa-mail-list-store';
import { mailStore } from 'owa-mail-store';
/**
 * Create the item contexts for triage actions that need delete store update
 * @param itemIds of the items that need to be updated in store
 * @returns the item contexts to be used to update the store
 */
export default function createItemContextsForDeleteStoreUpdate(itemIds) {
    var itemContexts = itemIds.map(function (itemIdValue) {
        var item = mailStore.items.get(itemIdValue);
        var isReadValue;
        if (isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    return itemContexts;
}
//# sourceMappingURL=createItemContextsForDeleteStoreUpdate.js.map